import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import leftarrow from "../../Assets/Images/CreateBatch/Group27.png";
import rightarrow from "../../Assets/Images/CreateBatch/Group27(1).png";
import DatePicker from "react-datepicker";
import SearchCB from "../../Assets/Images/CreateRole/Search.png";
import "react-datepicker/dist/react-datepicker.css";
import format from "date-fns/format"; // Add this line
// import DropDown from "./DropdownCB";
import DropDown from "./DropdownCBV2";
import { API_BASE_URL } from "../../Config/Config";
import Swal from "sweetalert2";
// import './customDatePicker.scss';
// import "./CreateBatch.css";
import "./CreateBatchV2.css";
import YellowSearch from "../../Assets/Images/CommanImages/searchyellow.png";
import BlankDropdown from "../CreateQuestionsPaper/DppScheduling/BlankDropdown";
const CreateBatch = (dataClient) => {
  // CommonJS
  const swal = require("sweetalert2");
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [sliderValue, setSliderValue] = useState([65, 70]);
  const [singleValue, setSingleValue] = useState({ year: 2014, month: 11 });
  const handleSliderChange = (value) => {
    setSliderValue(value);
  };
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedClassId, setSelectedClassId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  // const itemsPerPage = 25;
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [selectedButton, setSelectedButton] = useState(25);
  const user_name = dataClient?.dataClient?.client_schema_name[6][0].user_name;
  const clientBranchId =
    dataClient.dataClient?.client_schema_name[6][0].client_branch_id;
  const clientId = dataClient.dataClient?.client_schema_name[6][0].client_id;
  const [assignedStudents, setAssignedStudents] = useState([]);
  const [secondTableStudentIds, setSecondTableStudentIds] = useState([]);
  const [studentTypeId, setStudentTypeId] = useState(null);
  const [selectedStudentIds, setSelectedStudentIds] = useState([]);
  const [courses, setCourses] = useState([]);
  const [batchName, setBatchName] = useState("");
  const [courseOpted, setCourseOpted] = useState("");
  const [coachingMode, setCoachingMode] = useState("");
  // const [selectedClass, setSelectedClass] = useState([]);
  const [selectedClassName, setSelectedClassName] = useState("");
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [studentData, setStudentData] = useState([]);
  const [selectedClassObj, setSelectedClassObj] = useState(null);
  const [initialData, setInitialData] = useState([]);
  const [firstTableData, setFirstTableData] = useState([]);
  const [secondTableData, setSecondTableData] = useState([]);
  const [excludeAssigned, setExcludeAssigned] = useState(true);
  const [tentativeExamDate, setTentativeExamDate] = useState(new Date());
  // const [tentativeExamDate, setTentativeExamDate] = useState(new Date(2010, 0));
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [secondSearchTerm, setSecondSearchTerm] = useState("");
  const [secondTableCount, setSecondTableCount] = useState(0);
  const [firstTableCount, setFirstTableCount] = useState(0);

  const [batches, setBatches] = useState([]);
  const [batchDescription, setBatchDescription] = useState("");
  const [batchCode, setBatchCode] = useState("");
  const [selectedCourseName, setSelectedCourseName] = useState("");
  const coachingModeOptions = [
    { id: "Online", label: "Online" },
    { id: "Classroom", label: "Classroom" },
    { id: "Hybrid", label: "Hybrid" },
  ];
  const classTypeAbbreviations = {
    Online: "OL",
    Classroom: "CL",
    Both: "H",
  };
  const classTypeToId = {
    Online: 1,
    Classroom: 2,
    Both: 3,
  };

  const handleStyle = {
    borderRadius: 0,
    backgroundColor: "#EFEFEF",
    border: "2px solid #999999",
    height: "28px",
    width: "20px",
    opacity: 1,
  };

  const trackStyle = {
    backgroundColor: "#D6D6D6",
    height: "20px",
    border: "1px solid #999999",
  };

  const railStyle = {
    borderRadius: 0, // Add this line
    backgroundColor: "#FFFFFF",
    height: "20px",
    border: "2px solid #999999",
  };

  // Define state variables for selected course and class IDs

  useEffect(() => {
    const fetchCourses = async () => {
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-courses/`
      );
      const data = await response.json();
      setCourses(data);
    };

    fetchCourses();
  }, []);

  useEffect(() => {
    const fetchClasses = async () => {
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-classes/`
      );
      const data = await response.json();
      setSelectedClass(data); // Save the entire class object in the state
    };

    fetchClasses();
  }, []);

  // const handleBatchSelection = async (selectedBatchId) => {
  //   // Find the selected batch object
  //   const selectedBatch = batches.find(
  //     (batch) => batch.batch_id === selectedBatchId
  //   );

  //   // Set the selected batch
  //   setSelectedBatch(selectedBatch);

  //   if (selectedBatch) {
  //     // Find and set the matching course
  //     const matchedCourse = courses.find(
  //       (course) => course.course_id === selectedBatch.course_id
  //     );
  //     setSelectedCourse(matchedCourse);

  //     // Find and set the matching class
  //     const matchedClass = classes.find(
  //       (classObj) => classObj.class_id === selectedBatch.class_id
  //     );
  //     setSelectedClassObj(matchedClass);
  //   }
  // };

  const handleBatchSelection = async (selectedBatchId) => {
    // If there's already data in second table, show warning before switching batch
    if (secondTableData.length > 0) {
      const result = await Swal.fire({
        title: "Change Target Batch?",
        text: "Changing the batch will clear all selected students from the second table. Do you want to continue?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonColor: "rgb(100 101 101)",
        cancelButtonColor: "#318682",
      });

      if (!result.isConfirmed) {
        return; // If user clicks 'No', do nothing
      }

      // If confirmed, clear the second table
      setSecondTableData([]);
      setSelectedStudentIds([]);
    }

    // Proceed to change batch
    const selectedBatch = batches.find(
      (batch) => batch.batch_id === selectedBatchId
    );
    setSelectedBatch(selectedBatch);

    if (selectedBatch) {
      const matchedCourse = courses.find(
        (course) => course.course_id === selectedBatch.course_id
      );
      setSelectedCourse(matchedCourse);

      const matchedClass = classes.find(
        (classObj) => classObj.class_id === selectedBatch.class_id
      );
      setSelectedClassObj(matchedClass);
    }
  };

  useEffect(() => {
    const fetchBatches = async () => {
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-batches/`
      );
      const data = await response.json();
      setBatches(data.data);
    };

    fetchBatches();
  }, []);
  const handleCourseSelection = (selectedCourseId) => {
    // Find the selected course object
    const selectedCourse = courses.find(
      (course) => course.course_id === selectedCourseId
    );

    setSelectedCourse(selectedCourse);
    setSelectedCourseId(selectedCourse.course_id);
    setSelectedCourseName(selectedCourse.course_name);
  };

  const handleClassSelection = (selectedClassId) => {
    // Find the selected class object
    const selectedClassObj = classes.find(
      (classObj) => classObj.class_id === selectedClassId
    );

    setSelectedClassObj(selectedClassObj);
    setSelectedClassName(selectedClassObj.class_name);
  };
  const unassignStudents = () => {
    const selectedStudentsCopy = secondTableData.filter((student) =>
      selectedStudentIds.includes(student.student_id)
    );

    setFirstTableData((prevFirstTableData) => [
      ...prevFirstTableData,
      ...selectedStudentsCopy,
    ]);
    const newSecondTableData = secondTableData.filter(
      (student) => !selectedStudentIds.includes(student.student_id)
    );

    // Update the secondTableData state with the new array
    setSecondTableData(newSecondTableData);

    // Reset the selectedStudentIds
    setSelectedStudentIds([]);
  };

  const AssignBatch = async () => {
    if (!selectedBatch || !selectedCourse || !selectedClassObj) {
      Swal.fire({
        title: "Error",
        text: "Please select a Batch",
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
      return;
    }

    const studentsFormattedForSecondAPI = secondTableData.map((student) => ({
      student_id: student.student_id,
      added_by: user_name,
    }));

    const hasAssignedStudents = secondTableData.some(
      (student) => student.batch_name !== null
    );

    const postAssignedBatch = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/assign-batch?batch_id=${selectedBatch.batch_id}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(studentsFormattedForSecondAPI),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log(data);

        // Show success alert
        Swal.fire({
          title: "Success",
          text: "Batch assigned successfully",
          icon: "success",
          timer: 2000, // 2 seconds
          showConfirmButton: false,
        });

        // Reload the page after 2 seconds
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } catch (error) {
        console.error(error);
        Swal.fire({
          title: "Error in submitting the form",
          text: "Please fill all the input fields",
          icon: "error",
          confirmButtonColor: "rgb(100 101 101)",
        });
      }
    };

    if (hasAssignedStudents) {
      Swal.fire({
        title: "Are you sure?",
        text: "These students are already assigned batch, This will change there Batch . Are you sure you want to proceed?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonColor: "rgb(100 101 101)",
        cancelButtonColor: "#318682",
      }).then((result) => {
        if (result.isConfirmed) {
          postAssignedBatch(); // Call the function here
        }
      });
    } else {
      // If there are no assigned students, just post the students as they are
      postAssignedBatch();
    }
  };

  const [classes, setClasses] = useState([]);

  useEffect(() => {
    const fetchClasses = async () => {
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-classes/`
      );
      const data = await response.json();
      setClasses(data);
    };

    fetchClasses();
  }, []);

  // Update the useEffect hook
  // Fetch student data when selectedCourse or selectedClassObj changes
  useEffect(() => {
    if (selectedCourse && selectedClassObj) {
      const fetchStudentData = async () => {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/student-list-batch-assign/?course_id=${selectedCourse.course_id}&class_id=${selectedClassObj.class_id}&student_type_id=3&branch_id=${clientBranchId}`
        );
        let data = await response.json();

        data = mapEmptyBatchToNoBatch(data);

        setStudentData(data); // Save the student data in the state
      };

      fetchStudentData();
    }
  }, [selectedCourse, selectedClassObj]); // Listen for changes in both selectedCourse and selectedClassObj

  const assignStudents = () => {
    const selectedStudentsCopy = firstTableData.filter((student) =>
      selectedStudentIds.includes(student.student_id)
    );

    setSecondTableData((prevSecondTableData) => [
      ...prevSecondTableData,
      ...selectedStudentsCopy,
    ]);
    const newFirstTableData = firstTableData.filter(
      (student) => !selectedStudentIds.includes(student.student_id)
    );

    // Update the firstTableData state with the new array
    setFirstTableData(newFirstTableData);

    // Reset the selectedStudentIds
    setSelectedStudentIds([]);
  };

  // In your render method, when a checkbox is clicked
  const handleCheckboxClick = (studentId) => {
    setSelectedStudentIds((prevSelectedStudentIds) => {
      if (prevSelectedStudentIds.includes(studentId)) {
        // If the student is already selected, unselect them
        return prevSelectedStudentIds.filter((id) => id !== studentId);
      } else {
        // If the student is not selected, select them
        return [...prevSelectedStudentIds, studentId];
      }
    });
  };

  const mapEmptyBatchToNoBatch = (studentData) => {
    const transformedData = studentData.map((student) => ({
      ...student,
      batch_name: student.batch_name === "" ? "NoBatch" : student.batch_name,
    }));
    console.log(transformedData); // Add this line to log the transformed data
    return transformedData;
  };

  useEffect(() => {
    // Clear the table first
    setFirstTableData([]);

    // Use setTimeout to allow for the table to clear before setting the new data
    setTimeout(() => {
      // If excludeAssigned is true, only include students where batch_name is null
      if (excludeAssigned) {
        setFirstTableData(
          studentData.filter((student) => student.batch_name === null)
        );
      } else {
        setFirstTableData(studentData);
      }
    }, 0); // setTimeout with 0 delay ensures the clear operation happens first
  }, [excludeAssigned, studentData]);

  const handleCancel = () => {
    Swal.fire({
      title: "Are you sure you want to cancel?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "rgb(100 101 101)",
      cancelButtonColor: "#318682",
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire("Cancelled", "Your changes have been cancelled.", "success");
        window.location.reload();
      }
    });
  };
  useEffect(() => {
    setSecondTableCount(secondTableData.length);
  }, [secondTableData]);
  useEffect(() => {
    setFirstTableCount(firstTableData.length);
  }, [firstTableData]);

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "20px",
        marginBottom: "40px",
      }}
    >
      <div className="container-UP" style={{ position: "sticky", top: "0" }}>
        <div className="Header-up">
          <div className="col-cs-uni">
            <p className="title-cb">Assign Batch</p>
            <div style={{ marginTop: "10px" }} className="color424342">
              Batch assignment will be effective midnight
            </div>
          </div>
          <div className="mb-2-UP">
            <button className="cr-cancel-btn me-cs4" onClick={handleCancel}>
              CANCEL
            </button>
            <button className="cr-create-btn" onClick={AssignBatch}>
              SAVE
            </button>
          </div>
        </div>
        <hr
          style={{
            color: "black",
            backgroundColor: "black",
            marginTop: "5px",
          }}
        />
      </div>

      <div className="container-cs-fluid ms-cs3 mt-cs3">
        <div className="card-cs1 card-border-CR">
          <div className="basic-info-color  transparent-margin-left transparent-margin-all ">
            BASIC INFORMATION
          </div>

          <div className="row-cs grey-div-cs">
            <div className="col-cs color424342">
              <DropDown
                label="Target Batch"
                style={{ margin: "8px", width: "100%", marginTop: "5px" }}
                selected={selectedBatch ? selectedBatch.batch_id : null}
                setSelected={handleBatchSelection} // Use handleBatchSelection here
                options={batches.map((batch) => ({
                  id: batch.batch_id,
                  label: batch.batch_name,
                }))}
              />
            </div>

            <div className="col-cs">
              <div className=" color424342 " style={{ marginTop: "6px" }}>
                Description <span style={{ color: "red" }}>*</span>
              </div>
              <div className="">
                <input
                  type="text"
                  className="input-field-cv3"
                  style={{ padding: "5px", outline: "none" }}
                  value={selectedBatch ? selectedBatch.batch_description : ""}
                  disabled
                />
              </div>
            </div>
          </div>
        </div>

        <div className="card-cs1 grey-div-cs mt-cs4 card-border-CR">
          <div className="basic-info-color transparent-margin-left color424342 transparent-margin-all">
            ASSIGN STUDENT
          </div>
          <div style={{ marginBottom: "20px" }}>
            <div className="row-cs">
              <div className="col-cs-uni">
                {/* <div className="div-container-CB2">
                  <p style={{ marginBottom: "8px" }} className="color424342">
                    Course
                  </p>
                  <input
                    type="text"
                    className="input-field-cv2"
                    style={{ padding: "5px", outline: "none" }}
                    value={selectedCourse ? selectedCourse.course_name : ""}
                    disabled
                  />
                </div> */}
                <BlankDropdown
                  label="Course Name"
                  style={{
                    margin: "8px",
                    width: "95.4%",
                    marginTop: "5px",
                    marginLeft: "25px",
                  }}
                  selected={selectedCourse?.course_name || ""}
                />
              </div>

              <div className="col-cs-uni">
                {/* <div className="div-container-2-CB2">
                  <p style={{ marginBottom: "8px" }} className="color424342">
                    Class
                  </p>
                  <input
                    type="text"
                    className="input-field-cv2"
                    style={{ padding: "5px", outline: "none" }}
                    value={selectedClassObj ? selectedClassObj.class_name : ""}
                    disabled
                  />
                </div> */}
                <BlankDropdown
                  label="Class"
                  style={{
                    margin: "8px",
                    width: "90.9%",
                    marginTop: "5px",
                    marginLeft: "15px",
                  }}
                  selected={selectedClassObj?.class_name || ""}
                />
              </div>
            </div>
          </div>

          <hr className="dotted-hr ms-cs2 mb-cs2 " />
          {/* first table   */}
          <div className="row-cs">
            <div className="col-cs color424342" style={{ paddingLeft: "20px" }}>
              <div className="form-check transparent-margin-all">
                <input
                  className="form-check-input ms-cs3"
                  type="checkbox"
                  value=""
                  id="flexCheckChecked"
                  checked={excludeAssigned}
                  onChange={() => setExcludeAssigned(!excludeAssigned)}
                />
                <label
                  className="form-check-label mb-cs2 ms-cs2"
                  for="flexCheckChecked"
                >
                  Exclude students with assigned batch
                </label>
              </div>

              <div
                className="div-contains-search-cvb2"
                style={{ marginLeft: "2%" }}
              >
                <input
                  className="input-search-cvb2-2"
                  type="text"
                  onChange={(e) => setSearchTerm(e.target.value)}
                />

                <button
                  style={{
                    width: "5%",
                    backgroundColor: "white",
                    border: "none",
                  }}
                >
                  <img src={YellowSearch} className="search-cvb2-2" alt="" />
                </button>
              </div>

              <table className="table-CBV2-1">
                <tr style={{ border: "1px solid #999", height: "30px" }}>
                  {["Name", "Roll. No.", "Batch", "Type", "Mentor"].map(
                    (header) => (
                      <th style={{ border: "none", font: "18px" }}>{header}</th>
                    )
                  )}
                </tr>
                {firstTableData
                  .filter(
                    (student) => !excludeAssigned || student.batch_name !== ""
                  )
                  // .filter((student) =>
                  //   student.full_name
                  //     .toLowerCase()
                  //     .includes(searchTerm.toLowerCase())
                  // )
                  .filter((student) => {
                    const term = searchTerm.toLowerCase();
                    return (
                      student.full_name.toLowerCase().includes(term) ||
                      student.roll_number
                        .toString()
                        .toLowerCase()
                        .includes(term)
                    );
                  })
                  .slice(
                    (currentPage - 1) * itemsPerPage,
                    currentPage * itemsPerPage
                  )
                  .map((student, index) => (
                    <tr
                      style={{ border: "1px solid #999" }}
                      key={student.student_id}
                    >
                      <td>
                        <input
                          type="checkbox"
                          style={{ margin: "5px" }}
                          checked={selectedStudentIds.includes(
                            student.student_id
                          )}
                          onChange={() =>
                            handleCheckboxClick(student.student_id)
                          }
                        />
                        <span
                          style={{
                            display: "inline-block",
                            width: "100px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={student.full_name}
                        >
                          {student.full_name}
                        </span>
                      </td>

                      <td>{student.roll_number}</td>
                      <td>
                        {student.batch_name ? student.batch_name : "NoBatch"}
                      </td>
                      <td>
                        <div className="center-items-cbv2">
                          <div
                            className={
                              student.class_type_id === 1
                                ? "rounded-rectangle-CBV2"
                                : student.class_type_id === 2
                                ? "rounded-rectangle-2-CBV2"
                                : ""
                            }
                          ></div>
                        </div>
                      </td>
                      <td>
                        <span
                          style={{
                            display: "inline-block",
                            width: "120px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={student.mentor_name}
                        >
                          {student.mentor_name}
                        </span>
                      </td>
                    </tr>
                  ))}
              </table>

              {/* first table */}
              <div className="row-cs mt-cs3">
                <div className="col-cs">
                  {firstTableData.length > 0 && (
                    <>
                      <p className="mt-cs1 ms-cs3 color424342">
                        {
                          selectedStudentIds.filter((id) =>
                            firstTableData.some(
                              (student) => student.student_id === id
                            )
                          ).length
                        }{" "}
                        of {firstTableCount} selected.
                      </p>

                      <p className="mt-cs2 mb-cs2 ms-cs3 color424342">
                        Change table size :
                        <button
                          className={`table-size-change-buttons ${
                            selectedButton === 25 ? "selected" : ""
                          }`}
                          onClick={() => {
                            setItemsPerPage(25);
                            setSelectedButton(25);
                          }}
                        >
                          25
                        </button>
                        <button
                          className={`table-size-change-buttons ${
                            selectedButton === 50 ? "selected" : ""
                          }`}
                          onClick={() => {
                            setItemsPerPage(50);
                            setSelectedButton(50);
                          }}
                        >
                          50
                        </button>
                        <span>...</span>
                        <button
                          className={`table-size-change-buttons ${
                            selectedButton === 100 ? "selected" : ""
                          }`}
                          onClick={() => {
                            setItemsPerPage(100);
                            setSelectedButton(100);
                          }}
                        >
                          100
                        </button>
                      </p>
                    </>
                  )}
                </div>
                <div className="col-cs">
                  <div class="pagination-CBV2">
                    <a
                      href="#"
                      className="leftarrow-rounded"
                      onClick={() => setCurrentPage(1)}
                    >
                      <img
                        className="leftarrow-pagination"
                        src={leftarrow}
                        alt=""
                      />
                    </a>
                    <a href="#" onClick={() => setCurrentPage(currentPage - 1)}>
                      {"<"} {/* Previous page */}
                    </a>
                    {Array(Math.ceil(studentData.length / itemsPerPage))
                      .fill()
                      .map((_, index) => (
                        <a
                          href="#"
                          className={index + 1 === currentPage ? "active" : ""}
                          onClick={() => setCurrentPage(index + 1)}
                        >
                          {index + 1}
                        </a>
                      ))}
                    <a href="#" onClick={() => setCurrentPage(currentPage + 1)}>
                      {">"} {/* Next page */}
                    </a>
                    <a
                      href="#"
                      className="rightarrow-rounded"
                      onClick={() =>
                        setCurrentPage(
                          Math.ceil(studentData.length / itemsPerPage)
                        )
                      }
                    >
                      <img
                        className="rightarrow-pagination"
                        src={rightarrow}
                        alt=""
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-cs1">
              <button
                type="button"
                className="arrow-button-cs"
                onClick={assignStudents}
              >
                <p>
                  <i class="arrow right "></i>
                  <i class="arrow right margin-arrow-cs"></i>
                </p>
              </button>

              <button
                type="button"
                className="arrow-button-cs mt-cs4"
                onClick={unassignStudents}
              >
                <p>
                  <i class="arrow left margin-arrow-cs-2"></i>
                  <i class="arrow left "></i>
                </p>
              </button>
            </div>

            {/* second row  */}

            <div className="col-cs" style={{ marginRight: "1%" }}>
              <div class="form-check transparent-margin-all color424342">
                <label class="form-check-label" for="flexCheckChecked">
                  Student Count : {secondTableData.length}
                </label>
              </div>

              <div className="div-contains-search-cvb2">
                <input
                  className="input-search-cvb2"
                  type="text"
                  onChange={(e) => setSecondSearchTerm(e.target.value)}
                />
                <button
                  style={{
                    width: "5%",
                    backgroundColor: "white",
                    border: "none",
                  }}
                >
                  <img src={YellowSearch} className="search-cvb2" alt="" />
                </button>
              </div>

              <table className="table-CBV2-2 color424342">
                <tr style={{ border: "1px solid #999", height: "30px" }}>
                  {["Name", "Roll No.", "Batch", "Type", "Mentor"].map(
                    (header) => (
                      <th style={{ border: "none", font: "18px" }}>{header}</th>
                    )
                  )}
                </tr>
                {secondTableData
                  // .filter((student) =>
                  //   student.full_name
                  //     .toLowerCase()
                  //     .includes(secondSearchTerm.toLowerCase())
                  // )
                  .filter((student) => {
                    const term = secondSearchTerm.toLowerCase();
                    return (
                      student.full_name.toLowerCase().includes(term) ||
                      student.roll_number
                        .toString()
                        .toLowerCase()
                        .includes(term)
                    );
                  })

                  .map((student, index) => (
                    <tr
                      style={{ border: "1px solid #999" }}
                      key={student.student_id}
                    >
                      <td>
                        <input
                          type="checkbox"
                          style={{ margin: "5px" }}
                          checked={selectedStudentIds.includes(
                            student.student_id
                          )}
                          onChange={() =>
                            handleCheckboxClick(student.student_id)
                          }
                        />
                        <span
                          style={{
                            display: "inline-block",
                            width: "100px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={student.full_name}
                        >
                          {student.full_name}
                        </span>
                      </td>
                      <td>{student.roll_number}</td>
                      <td>
                        {student.batch_name ? student.batch_name : "NoBatch"}
                      </td>
                      <td>
                        <div className="center-items-cbv2">
                          <div
                            className={
                              student.class_type_id === 1
                                ? "rounded-rectangle-CBV2"
                                : student.class_type_id === 2
                                ? "rounded-rectangle-2-CBV2"
                                : ""
                            }
                          ></div>
                        </div>
                      </td>
                      <td>
                        {" "}
                        <span
                          style={{
                            display: "inline-block",
                            width: "120px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={student.mentor_name}
                        >
                          {student.mentor_name}
                        </span>
                      </td>
                    </tr>
                  ))}
              </table>
              <div className="row-cs mt-cs3">
                <div className="col-cs">
                  {/* <p className="mt-cs1 ms-cs3 color424342">
                    {selectedStudentIds.length} of {studentData.length}{" "}
                    selected.
                  </p> */}
                  <p className="mt-cs1 ms-cs3 color424342">
                    {
                      selectedStudentIds.filter((id) =>
                        secondTableData.some(
                          (student) => student.student_id === id
                        )
                      ).length
                    }{" "}
                    of {secondTableCount} selected.
                  </p>
                </div>
                <div className="col-cs">
                  <div class="pagination-cs-2">
                    <a
                      href="#"
                      className="leftarrow-rounded"
                      onClick={() => setCurrentPage(1)}
                    >
                      <img
                        className="leftarrow-pagination "
                        src={leftarrow}
                        alt=""
                      />
                    </a>
                    <a href="#" onClick={() => setCurrentPage(currentPage - 1)}>
                      {"<"} {/* Previous page */}
                    </a>
                    {Array(Math.ceil(secondTableData.length / itemsPerPage))
                      .fill()
                      .map((_, index) => (
                        <a
                          href="#"
                          className={index + 1 === currentPage ? "active" : ""}
                          onClick={() => setCurrentPage(index + 1)}
                        >
                          {index + 1}
                        </a>
                      ))}
                    <a href="#" onClick={() => setCurrentPage(currentPage + 1)}>
                      {">"} {/* Next page */}
                    </a>
                    <a
                      href="#"
                      className="rightarrow-rounded"
                      onClick={() =>
                        setCurrentPage(
                          Math.ceil(secondTableData.length / itemsPerPage)
                        )
                      }
                    >
                      <img
                        className="rightarrow-pagination"
                        src={rightarrow}
                        alt=""
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateBatch;
